import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { wrapDisplayName } from 'recompose';
import { withClient } from '@deerplusofficial/pos-hoc';
import {
  getResult,
  createCancelToken,
  mapState,
} from '@deerplusofficial/pos-helper';
import actions from '../../actions';

const {
  enable: enableCheckPayment,
  disable: disableCheckPayment,
} = actions.payment.check;

export default config => Component =>
  fp.compose(
    withClient(),
    connect(
      mapState(['payment']),
      { enableCheckPayment, disableCheckPayment }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryPayment');

      componentWillUnmount() {
        !_.isUndefined(this.cancelCheckPayment) && this.cancelCheckPayment();
      }

      onPaymentCheck = async () => {
        const {
          enableCheckPayment,
          disableCheckPayment,
          payment: { id },
          client: { POSApi, onError },
        } = this.props;

        if (!id) return;

        try {
          enableCheckPayment();

          const { payment } = getResult(
            await POSApi.get(`/payments/${id}/check`, {
              cancelToken: createCancelToken(this.cancelCheckPayment),
            })
          );

          return payment;
        } catch (e) {
          onError(e);
        } finally {
          disableCheckPayment();
        }
      };

      render() {
        return (
          <Component {...this.props} onPaymentCheck={this.onPaymentCheck} />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryPayment.js